<template>
  <div>
    <div class="selected-color" v-bind:class="{ 'slided-up': showLikeThisColor }" v-on:click="showLikeThisColor = !showLikeThisColor">
      <p><strong>{{selectedColor.colourName.toLowerCase()}}</strong></p>
      <span>{{selectedColor.id}}</span>
    </div>
    <div class="like-this-color" v-bind:class="{ visible: selectedColor && showLikeThisColor }" v-on:click="showResult(selectedColor)">
      <div class="arrow-down" v-bind:style="{ borderTopColor: backgroundColor }"></div>
      <div class="text">
        <strong>Like this colour?</strong><br/>
        Tap to skip the quiz and view this colour.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectedColor',
  props: {
    backgroundColor: String
  },
  data() {
    return {
      showLikeThisColor: false
    }
  },
  computed: {
    selectedColor: function() {
      return this.$store.state.selectedColor;
    }
  },
  watch: {
    selectedColor() {
      this.showLikeThisColor = false;
    }
  },
  mounted() {
  },
  methods: {
    showResult(item) {
      this.$store.commit('updateSelectedColor', item)
      this.$store.commit('isListOrGridView', 'list')
      this.$router.push('/results')
    }
  }
}
</script>
